export class UserLoginModel {
    public UserName:string;
    public Password:string;
}
